import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Optional, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CuttingPaymentData, CuttingPaymentResponseDto, NgxLocalizedNumbersService } from 'cloud-shared-lib';

import { PaymentsService } from '../payments.service';

@Component({
  selector: 'cutting-wooppay-pay-dialog',
  templateUrl: './wooppay-pay-dialog.component.html',
  styleUrls: ['./wooppay-pay-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    MatToolbarModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatLegacySnackBarModule,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class WooppayPayDialogComponent {
  amount: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.max(252500),
    Validators.pattern(/^\d+$/),
    Validators.min(1),
  ]);
  currentCurrencySign = '';

  public paymentFeeMsg = '';

  constructor(
    private ref: ChangeDetectorRef,
    private paymentsService: PaymentsService,
    public dialogRef: MatDialogRef<WooppayPayDialogComponent>,
    private snackBar: MatSnackBar,
    private localizedNumbersService: NgxLocalizedNumbersService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: any
  ) {
    this.amount.setValue(this.data.amount);

    this.currentCurrencySign = this.localizedNumbersService.getCurrentLocaleDefinition().currency;

    if (this.data.commission_percent > 0) {
      this.paymentFeeMsg = $localize`Внимание! При выборе данного способа оплаты взымается дополнительная комиссия в
      размере ${this.data.commission_percent}% от суммы платежа. Она будет прибавлена к введённой вами сумме.`;
    }
  }

  public payWooppayClick(): void {
    const paymentData: CuttingPaymentData = new CuttingPaymentData({
      amount: +this.amount.value,
      orderId: this.data.orderId,
    });

    this.paymentsService
      .getWooppayPaymentParams(paymentData)
      .then((rdata: CuttingPaymentResponseDto) => {
        if (rdata) {
          this.onLoadinfPaymingInformation(rdata);
        } else {
          this.snackBar.open($localize`Не удалось выполнить платеж`);
        }
      })
      .catch((error: any) => console.error(error));
  }

  public onLoadinfPaymingInformation(rdata: CuttingPaymentResponseDto): void {
    this.ref.detectChanges();

    this.amount.setValue(rdata.amount.toFixed(2));

    window.open(rdata.hmac, '_blank');

    this.dialogRef.close();
  }

  getErrorMessage(): string {
    const mess = this.amount.hasError('required')
      ? $localize`Необходимо ввести значение`
      : this.amount.hasError('max')
      ? $localize`Максимальное значение - 252500`
      : this.amount.hasError('pattern')
      ? $localize`Поле должно содержать только цифры`
      : this.amount.hasError('min')
      ? $localize`Сумма не должна быть равна нулю`
      : '';

    return mess;
  }
}
